exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#main-cont-eod {\n  margin-top: 24px;\n  background: #FFFFFF;\n  border: 1px solid #ddd;\n  padding-top: 12px;\n  padding-bottom: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/eod-recon/eod-recon.component.scss
// module id = ../../../../../src/app/views/daily-recon/eod-recon/eod-recon.component.scss
// module chunks = main